/* Breasties: show 1 / 2 / 3 boxes on each pack option in the buy box.
   Each box shows the photo of the variant picked for that pair (shade + size),
   falling back to the "Included free" box photo, then the product photo. */
(function () {
  var d = document;
  var css = '' +
    '.bz-pack{grid-template-columns:22px 64px 1fr auto;grid-template-areas:"r v t p" "r v n e"}' +
    '.bz-pack__viz{grid-area:v;position:relative;width:64px;height:48px}' +
    '.bz-pack__viz img{position:absolute;top:4px;width:40px;height:40px;object-fit:cover;border-radius:9px;background:#fff;border:2px solid #fff;box-shadow:0 4px 10px -4px rgba(59,42,32,.45);transition:transform .2s}' +
    '.bz-pack__viz img:nth-child(1){left:0;z-index:3}' +
    '.bz-pack__viz img:nth-child(2){left:12px;z-index:2;transform:rotate(6deg) translateY(-2px)}' +
    '.bz-pack__viz img:nth-child(3){left:24px;z-index:1;transform:rotate(12deg) translateY(-4px)}' +
    '.bz-pack__viz[data-n="1"] img{left:12px}' +
    '.bz-pack__viz[data-n="2"] img:nth-child(1){left:6px}.bz-pack__viz[data-n="2"] img:nth-child(2){left:18px}' +
    '.bz-pack[aria-checked=true] .bz-pack__viz img:nth-child(2){transform:rotate(8deg) translateY(-3px)}' +
    '.bz-pack[aria-checked=true] .bz-pack__viz img:nth-child(3){transform:rotate(15deg) translateY(-6px)}' +
    '@media (max-width:899px){' +
      '.bz-pack{grid-template-columns:1fr;grid-template-areas:"v" "t" "p" "e"}' +
      '.bz-pack__viz{justify-self:center;margin:2px 0 4px;width:64px;height:46px}' +
      '.bz-pack__badge .bz-bl{display:none}' +
    '}';

  function boxSrc(sec) {
    var g = sec.querySelector('.bz-inc__img img');
    if (g) return g.currentSrc || g.src;
    var j = sec.querySelector('[data-bz-json]');
    try { return JSON.parse(j.textContent).image || ''; } catch (e) { return ''; }
  }
  function run(scope) {
    (scope || d).querySelectorAll('[data-bz-product]').forEach(function (sec) {
      var src = boxSrc(sec); if (!src) return;
      sec.querySelectorAll('[data-bz-pack]').forEach(function (b) {
        if (b.querySelector('.bz-pack__viz')) return;
        // "Most popular · 63% off": keep only the last part on small screens
        var bd = b.querySelector('.bz-pack__badge');
        if (bd && bd.textContent.indexOf(' · ') > -1) {
          var parts = bd.textContent.split(' · '), last = parts.pop();
          bd.innerHTML = '';
          var a = d.createElement('span'); a.className = 'bz-bl'; a.textContent = parts.join(' · ') + ' · ';
          bd.appendChild(a); bd.appendChild(d.createTextNode(last));
        }
        var n = Math.min(+b.getAttribute('data-pairs') || 1, 3);
        var v = d.createElement('span');
        v.className = 'bz-pack__viz'; v.setAttribute('data-n', n); v.setAttribute('aria-hidden', 'true');
        for (var i = 0; i < n; i++) { var im = d.createElement('img'); im.src = src; im.alt = ''; im.loading = 'lazy'; im.width = 40; im.height = 40; v.appendChild(im); }
        b.insertBefore(v, b.firstChild);
      });
    });
  }
  function variantImgs(sec) {
    var j; try { j = JSON.parse(sec.querySelector('[data-bz-json]').textContent); } catch (e) { return []; }
    var rows = sec.querySelectorAll('[data-bz-pairs] .bz-pr'), out = [];
    rows.forEach(function (r) {
      var sh = r.querySelector('[data-bz-pick-shade][aria-checked="true"]'), sz = r.querySelector('[data-bz-pick-size][aria-checked="true"]');
      var shade = sh ? sh.getAttribute('data-bz-pick-shade') : null, size = sz ? sz.getAttribute('data-bz-pick-size') : null;
      var v = (j.variants || []).filter(function (x) { return (!shade || x.shade === shade) && (!size || x.size === size); })[0]
           || (j.variants || []).filter(function (x) { return shade && x.shade === shade; })[0];
      out.push(v && v.img ? v.img : '');
    });
    return out;
  }
  function paint(sec) {
    var imgs = variantImgs(sec), fb = boxSrc(sec);
    sec.querySelectorAll('.bz-pack__viz').forEach(function (v) {
      v.querySelectorAll('img').forEach(function (im, i) {
        var src = imgs[i] || imgs[0] || fb;
        if (src && im.getAttribute('src') !== src) im.setAttribute('src', src);
      });
    });
  }
  function watch(sec) {
    if (sec.__bzPaint) return; sec.__bzPaint = true;
    var queued = false, go = function () { if (queued) return; queued = true; setTimeout(function () { queued = false; paint(sec); }, 0); };
    var p = sec.querySelector('[data-bz-pairs]');
    if (p && 'MutationObserver' in window) new MutationObserver(go).observe(p, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-checked'] });
    sec.addEventListener('click', function () { setTimeout(go, 0); });
    sec.addEventListener('change', function () { setTimeout(go, 0); });
    go();
  }
  var _run = run;
  run = function (scope) { _run(scope); (scope || d).querySelectorAll('[data-bz-product]').forEach(watch); };

  var st = d.createElement('style'); st.textContent = css; d.head.appendChild(st);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  d.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
